import { Errors } from '@/constants/errors';
import type { ApiError } from '@/services/apiClient';

export const getErrorMessage = (error: unknown, fallbackMessage: string): string => {
  const apiError = error as ApiError | undefined;
  const errorInfo = apiError?.info;

  if (typeof errorInfo === 'string' && errorInfo.trim()) {
    return errorInfo;
  }

  if (errorInfo && typeof errorInfo === 'object') {
    const message =
      (errorInfo as { message?: string; error?: { message?: string } }).message ||
      (errorInfo as { message?: string; error?: { message?: string } }).error?.message;

    if (message?.trim()) {
      return message;
    }
  }

  return fallbackMessage;
};

export function checkIfServerFinalizeFailure(error: unknown): boolean {
  return error instanceof Error && (error as Error)?.message === Errors.global.failedToSendPayment;
}
